import { Skeleton } from "@mantine/core";
import styles from "../category/styles/Category.module.css";
import curated from "./styles/Curated.module.css";

const placeholders = (count: number) => Array.from({ length: count }, (_, i) => i);

interface CuratedSkeletonProps {
    label: string;
    /** "tiles" mirrors the list pages, "list" the detail pages */
    variant: "tiles" | "list";
}

/** Loading state shaped like CuratedHero plus the content below it, so the page does not jump. */
export const CuratedSkeleton = ({ label, variant }: CuratedSkeletonProps) => (
    <div aria-busy="true" aria-label={label}>
        <section className={`${styles.hero} ${variant === "tiles" ? curated.textOnly : ""}`}>
            <div className={styles.heroCopy}>
                <Skeleton height={14} mb="sm" width={140} />
                <Skeleton height={56} mb="md" width="55%" />
                <Skeleton height={14} mb={8} width="90%" />
                <Skeleton height={14} mb={8} width="80%" />
                <Skeleton height={14} width="60%" />
            </div>
            {variant === "list" && (
                <div className={curated.mosaic}>
                    {placeholders(6).map((i) => (
                        <Skeleton className={curated.cover} key={i} radius="md" />
                    ))}
                </div>
            )}
        </section>

        {variant === "tiles" ? (
            <div className={curated.tiles}>
                {placeholders(6).map((i) => (
                    <Skeleton height={220} key={i} radius="md" />
                ))}
            </div>
        ) : (
            <section className={styles.section}>
                <Skeleton height={32} mb="md" width={220} />
                <div className={styles.showGrid}>
                    {placeholders(6).map((i) => (
                        <Skeleton height={112} key={i} radius="md" />
                    ))}
                </div>
            </section>
        )}
    </div>
);
